// redux/detalheplanoReducer.js

const DETALHEPLANO_FETCH_REQUEST = 'DETALHEPLANO_FETCH_REQUEST'
const DETALHEPLANO_FETCH_SUCCESS = 'DETALHEPLANO_FETCH_SUCCESS'
const DETALHEPLANO_FETCH_FAILURE = 'DETALHEPLANO_FETCH_FAILURE'
const DETALHEPLANO_CLEAR = 'DETALHEPLANO_CLEAR'

const initialState = {
  loading: false,
  data: null,
  error: null
}

export default function detalheplanoReducer(state = initialState, action) {
  switch (action.type) {
    case DETALHEPLANO_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case DETALHEPLANO_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      }

    case DETALHEPLANO_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case DETALHEPLANO_CLEAR:
      return initialState

    default:
      return state
  }
}

export {
  DETALHEPLANO_FETCH_REQUEST,
  DETALHEPLANO_FETCH_SUCCESS,
  DETALHEPLANO_FETCH_FAILURE,
  DETALHEPLANO_CLEAR
}